/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Disable newsletter "Join" buttons until the marketing consent checkbox is checked
  function setNewsletterButtonState(form) {
    var checkbox = form.querySelector('[data-newsletter-acceptance-checkbox]');
    var button = form.querySelector('[data-newsletter-submit]');
    if (!checkbox || !button) return;
    button.disabled = !checkbox.checked;
  }

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-newsletter-acceptance-checkbox]')) return;
    var form = event.target.closest('[data-newsletter-form]');
    if (form) setNewsletterButtonState(form);
  });

  document.querySelectorAll('[data-newsletter-form]').forEach(setNewsletterButtonState);



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
